import React from 'react';
import {StyleSheet, View} from 'react-native'

export default ({children}) => {
    return (
    <View style={styles.body}>
        {children}
    </View>
    );
  };

  const styles = StyleSheet.create({
  body: {
    backgroundColor: '#222555',
    flex: 1,
  }
});
  